import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";




function Facilities() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
           <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Facilities <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="#1D4D93"/>
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-3"><b>FACILITIES  </b></h1>
                            <div className="col-md-3">
                                <hr style={{color:"#1D4D93"}}/>
                                </div>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">
                                    
                                    <div className="col-md-12 mt-3">
                                        <p className='mb-3'>Children are unique individuals who deserve a loving, secure environment that promotes a sense of wonder and discovery in learning. The modern state-of-the-art infrastructure boasts of Smart Classrooms combined with amenities designed to provide the finest of facilities to make the learning experience a meaningful and joyful one for our students. </p>
                                        <h5 className='mb-1' style={{color:"#0f2d5b"}}><b>Lush Green Campus :-</b></h5>
                                        <p className='justify mb-3'>The school building is adjacent to a vast playground and surrounded with lush green lawns where the students take part in both organized team sports and free play.  </p>
                                       
                                        <h5 className='mb-1' style={{color:"#0f2d5b"}}><b>Safe & Student Friendly Environment:-</b></h5>
                                        <p className='justify mb-3'>We provide a safe, caring and happy community in which children can learn and have fun. All our teachers and staff are regularly trained with the latest child safety norms and strictly adhere to the Blue-Ribbon Policy. Our eco-friendly furniture complies with all safety norms.  </p>


                                        <h5 className='mb-1' style={{color:"#0f2d5b"}}><b>GPS Enabled School Transport Facilities :-</b></h5>
                                        <p className='justify mb-3'>The school boasts of the finest fleet of modern buses that ply across the neighbourhood and adjoining areas carrying students safely to and from the school. All our busses and vehicles are enabled with the latest technology to ensure GPS tracking at all times helping parents get updates on their wards' location.   </p>

                                        <h5 className='mb-1' style={{color:"#0f2d5b"}}><b>CCTV Surveillance :-</b></h5>
                                        <p className='justify mb-3'>The school building is fully IT enabled and the campus boasts of a 100% CCTV monitoring ensuring the utmost safety of every child. </p>

                                        <h5 className='mb-1' style={{color:"#0f2d5b"}}><b>Spacious Digital Classrooms :-</b></h5>
                                        <p className='justify mb-3'>Our large, airy classrooms are WiFi enabled with digital boards and other latest education technology. </p>


                                        <h5 className='mb-1' style={{color:"#0f2d5b"}}><b>Well Stocked Library :-</b></h5>
                                        <p className='justify mb-3'>KPS proudly showcases a vast collection of textbooks, journals, dailies, reference materials, question banks, encyclopedias and books simply meant for the pleasure of reading in our well stocked library. The school library plays a great role in the life of students by serving as the store house of knowledge.  </p>

<h5 className='mb-1' style={{color:"#0f2d5b"}}><b>Well Equipped Laboratories :-</b></h5>
                                        <p className='justify mb-3'>Our well-equipped, sophisticated laboratories for the all Science Subjects, Mathematics, Geography and IT/Computer Science enables hands-on experiential learning. The practical demonstration and activity-based methodology generates curiosity among students and inspires them to explore the spirit of inventiveness and creativity.  </p>

                                        <h5 className='mb-1' style={{color:"#0f2d5b"}}><b>Indoor & Outdoor Sports Facilities :-</b></h5>
                                        <p className='justify mb-3'> We have a vast playground adjacent to the school building that favours all kinds of outdoor sporting facilities. It also possesses latest infrastructure and specialized coaches and trainers to facilitate various sports, martial arts and other health and fitness programme. The school offers a host of indoor sporting facilities and ensure that the students are trained in such sports by expert trainers. </p>

<h5 className='mb-1' style={{color:"#0f2d5b"}}><b>Medical Care :-</b></h5>
                                        <p className='justify mb-3'> The school has a well-equipped infirmary with full-time medical aide to attend to children in case of any emergency or accident. </p>
                                        <h5 className='mb-1' style={{color:"#0f2d5b"}}><b>Digital Attendance Managing System :-</b></h5>
                                        <p className='justify mb-3'>Along with the manual recording system monitored by the Class Teacher, we boast of the latest technology based Digital Attendance Managing System to maintain accurate records and enable regular notification and follow up with parents. </p>



                                    </div>
                                    
                                       


                                      
                                </div>
                            </div>
                        </div>
                        <br />





                    </div>
                </div>
            </div>



        </div>
    )
}

export default Facilities